<template>
    <section>
        <ds-modal
            :is-open="isManageLinkTypesModalOpen"
            :title.sync="modalTitle"
            :size="modalSize"
            class="regular-modal"
            show-back
            @back="backFromManageLinkType"
        >
            <div class="search">
                <ds-input-field
                    v-model="searchCriteria"
                    class="search-contact"
                    placeholder="Search"
                    type="input"
                >
                    <ds-icon slot="leading" name="search" />

                    <span
                        v-show="searchCriteria"
                        slot="trailing"
                        class="clear-icon"
                        @click="clearSearch"
                    >
                        <ds-icon name="x" />
                    </span>
                </ds-input-field>

                <ds-outline-button class="new-link-type" @click="editManageLink({})">
                    New Link Type
                </ds-outline-button>
            </div>

            <table class="contact-table-details">
                <tr data-qa="manage-link-head">
                    <th>Edit</th>

                    <th>Name</th>

                    <th>Max</th>
                </tr>

                <tr
                    v-for="(sField, sysIndex) in searchContactResults"
                    :key="sField.id"
                    border-style="none"
                    class="contact-details-row"
                    clickable
                >
                    <td>
                        <a @click="editManageLink(sField)">[ Edit ]</a>
                    </td>

                    <td>{{ sField.typeName }}</td>

                    <td>{{ sField.maxLinked }}</td>
                </tr>
            </table>
        </ds-modal>

        <edit-manage-link-type ref="editManageLinkTypes" :linked-contact-types="linkedContactTypes" @openManageLinkTypes="openManageLinkTypes" />
    </section>
</template>
<script>
const RENDER_LIMIT = 1000;

import EditManageLinkType from './EditManageLinkType';
import axios from 'axios';

export default {

    components: { EditManageLinkType },

    data() {
        return {
            modalSize: 'xl',
            modalTitle: 'Manage Link Types',
            linkedContactTypes: [],
            searchCriteria: '',
            reloadLinkedContact: false,
            isManageLinkTypesModalOpen: false,
        };
    },

    computed: {
        searchContactResults() {
            const contactData = this.linkedContactTypes && this.linkedContactTypes.length > 0 ? this.linkedContactTypes.map((x) => x) : [];

            return this.searchFieldsData(contactData);
        },


        searchConditions() {
            return new RegExp(this.searchCriteria, 'gi');
        },

        searchFieldsData() {
            return (searchData) => {
                if (this.searchCriteria) {
                    const searchResults = [];

                    for (let cIdx = 0; cIdx < searchData.length && searchResults.length < RENDER_LIMIT; cIdx++) {
                        if (searchData[cIdx].typeName !== null && searchData[cIdx].typeName.match(this.searchConditions)) {
                            searchResults.push(searchData[cIdx]);
                        }
                    }

                    return searchResults;
                }

                if (this.searchCriteria) {
                    return searchData.filter(({ label }) => label.typeName.match(this.searchConditions));
                }

                return searchData;
            };
        },
    },

    methods: {
        backFromManageLinkType() {
            this.$emit('backToLinkedContacts', this.reloadLinkedContact);
            this.reloadLinkedContact = false;
            this.closeModal();
        },

        closeModal() {
            this.isManageLinkTypesModalOpen = false;
        },

        openManageLinkTypes(value) {
            this.reloadLinkedContact = value;

            if (value) {
                this.loadManageLinkTypes();
            } else {
                this.isManageLinkTypesModalOpen = true;
            }
        },

        editManageLink(linkType) {
            this.$refs.editManageLinkTypes.editManageType(linkType);
        },

        clearSearch() {
            this.searchCriteria = '';
        },

        async loadManageLinkTypes(search) {
            try {
                const response = await axios.get('/app/contact/getManageLinkTypes');

                this.linkedContactTypes = response.data;
            } catch (error) {
                this.$error({ message: 'error occurred while getting all manage link types' });
            }

            this.searchCriteria = search;
            this.isManageLinkTypesModalOpen = true;
        },
    },
};
</script>
<style lang="scss" scoped>
    .contact-table-details{
        cursor: pointer;
        border-collapse: collapse;
        border-top: 1px solid $color-gray-lighter;
        width: 100%;
        margin-top: $spacing-250;
    }

    .contact-details-row:hover {
        background-color: $color-gray-20;
    }

    .search-contact {
        width: px-to-rem(320px);
        margin-right: $spacing-400;
    }

    .clear-icon {
        --icon-color: #{$color-ink};
        cursor: pointer;
    }

    .search {
        display: flex;
        justify-content: space-between;
    }

    .new-link-type {
        place-self: end;
    }
</style>
